import { DatePipe } from '@angular/common';
import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { fadeInAnimation } from 'app/core/route-animation/route.animation';
import { AuthService } from 'app/services/auth.service';
import { CommonUtilService } from 'app/services/commonUtil.service';
import { ReportService } from 'app/services/report.service';
import { SpinnerService } from 'app/services/spinner.service';

@Component({
  selector: 'ms-candidate-list',
  templateUrl: './candidate-list.component.html',
  styleUrls: ['./candidate-list.component.css'],
  encapsulation: ViewEncapsulation.None,
  host: {
    "[@fadeInAnimation]": 'true'
  },
  animations: [fadeInAnimation]
})
export class CandidateListComponent implements OnInit, AfterViewInit {

  @ViewChild('hdrTplWithNoSearch') hdrTplWithNoSearch: TemplateRef<any>;
  @ViewChild('hdrTplWithTextSearch') hdrTplWithTextSearch: TemplateRef<any>;
  @ViewChild('hdrTplWithDateCreatedSearch') hdrTplWithDateCreatedSearch: TemplateRef<any>;

  @ViewChild('createDateTpl') createDateTpl: TemplateRef<any>;
  @ViewChild('birthDateTpl') birthDateTpl: TemplateRef<any>;
  @ViewChild('indirizzoTpl') indirizzoTpl: TemplateRef<any>;
  @ViewChild('nameTpl') nameTpl: TemplateRef<any>;
  @ViewChild('emailTpl') emailTpl: TemplateRef<any>;
  @ViewChild('taxCodeTpl') taxCodeTpl: TemplateRef<any>;
  @ViewChild('scoreTpl') scoreTpl: TemplateRef<any>;
  @ViewChild('worstTpl') worstTpl: TemplateRef<any>;
  @ViewChild('stimaTpl') stimaTpl: TemplateRef<any>;
  @ViewChild('eventiTpl') eventiTpl: TemplateRef<any>;
  @ViewChild('actionCellTpl') actionCellTpl: TemplateRef<any>;
  @ViewChild('subjectTpl') subjectTpl: TemplateRef<any>;

  rows = [];
  columns = [];
  dataRows = [];
  excelRows = [];
  defaultSort = [
    {
      prop: 'reportDate',
      dir: 'desc'
    }
  ];

  previousCreationDateFilter: Date = null;
  previousRequestNumberFilter = '';
  previousFiscalCodeFilter = '';
  previousFullNameFilter = '';
  previousEmailFilter = '';

  header: string[] = [];

  constructor(
    private reportService: ReportService,
    private commonUtilService: CommonUtilService,
    private spinnerService: SpinnerService,
    private datePipe: DatePipe,
    private auth: AuthService,
    private router: Router) {

    this.spinnerService.start();
    this.reportService.getTableCandidates(this.auth.isAdmin()).subscribe(data => {
      this.rows = data;
      this.dataRows = data;
      /* console.log(this.rows); */
      this.spinnerService.stop();
    });
  }

  ngAfterViewInit(): void {
    this.columns = [
      { name: "Nome Report", width: 200, sortable: true, resizeable: false, cellTemplate: this.subjectTpl },
      /* { name: 'Numero Visura', prop: 'reportNumber', headerTemplate: this.hdrTplWithNoSearch, width: 250, sortable: true, resizeable: false }, */
      { name: 'Data Report', headerTemplate: this.hdrTplWithDateCreatedSearch, cellTemplate: this.createDateTpl, comparator: this.columnCreateDateComparator.bind(this), width: 150, sortable: true, resizeable: false },
      /* { name: 'Numero Report', prop: 'requestNumber', headerTemplate: this.hdrTplWithTextSearch, width: 180, sortable: true, resizeable: false }, */
      { name: 'Nome e cognome', cellTemplate: this.nameTpl, headerTemplate: this.hdrTplWithTextSearch, width: 200, sortable: true, resizeable: false },
      { name: 'Email', cellTemplate: this.emailTpl, headerTemplate: this.hdrTplWithTextSearch, width: 200, sortable: true, resizeable: false },
      /* { name: 'Indirizzo', cellTemplate: this.indirizzoTpl, width: 300, sortable: true, resizeable: false }, */
      /* { name: 'Codice fiscale', cellTemplate:this.taxCodeTpl, headerTemplate: this.hdrTplWithTextSearch, width: 200, sortable: true, resizeable: false }, */
      /* { name: 'Data di nascita', cellTemplate: this.birthDateTpl, width: 150, resizeable: false, comparator: this.columnBirthDateComparator.bind(this), sortable: true}, */
      { name: 'Score Degrade', cellTemplate: this.scoreTpl, sortable: true, width: 150, resizeable: false },
      { name: 'Worst 5%', cellTemplate: this.worstTpl, sortable: true, width: 100, resizeable: false },
      { name: 'Stima Reddito', cellTemplate: this.stimaTpl, sortable: true, width: 130, resizeable: false },
      { name: 'Eventi Negativi', cellTemplate: this.eventiTpl, sortable: true, width: 150, resizeable: false },
      { name: 'Azioni', sortable: false, width: 200, resizeable: false, cellTemplate: this.actionCellTpl }
    ];
  }

  ngOnInit(): void {
    this.commonUtilService.translateLang("HRWE.REPORT.ALL_CANDIDATE");
  }

  parseDateOfBirth(val) {
    if (val != null) {
      let date = new Date(val);
      if (date != null && !date.toString().includes("Invalid Date")) {
        let outputDate = this.datePipe.transform(date, 'dd/MM/yyyy');
        return outputDate;
      }
    }
  }

  filterByText(event, columnName) {

    this.spinnerService.start();

    const filter = event.target.value;
    switch (columnName) {
      case "Numero richiesta":
        this.previousRequestNumberFilter = filter;
        break;
      case "Nome e cognome":
        this.previousFullNameFilter = filter;
        break;
      case "Codice fiscale":
        this.previousFiscalCodeFilter = filter;
        break;
      case "Email":
        this.previousEmailFilter = filter;
        break;
    }
    this.rows = this.filterRows();
  }

  filterByCreationDate(event) {
    //console.log("filterByCreationDate " + event.target.value);
    this.spinnerService.start();
    if (event.target.value != '') {
      const filter = event.target.value;
      var selectedDate = new Date(filter);
      selectedDate.setHours(0, 0, 0, 0);
      this.previousCreationDateFilter = selectedDate;
    } else {
      this.previousCreationDateFilter = null;
    }
    this.rows = this.filterRows();
  }

  filterRows(): any[] {
    this.rows = this.dataRows;

    return this.rows.filter(row => {
      const isPartialRequestNumber = !this.previousRequestNumberFilter || row.requestNumber.indexOf(this.previousRequestNumberFilter) !== -1;
      const isPartialFullName = !this.previousFullNameFilter || (row.fullName && row.fullName.toLowerCase().indexOf(this.previousFullNameFilter) !== -1);
      const isPartialEmail = !this.previousEmailFilter || (row.email && row.email.toLowerCase().indexOf(this.previousEmailFilter) !== -1);
      const isPartialFiscalCode = !this.previousFiscalCodeFilter || (row.fiscalCode && row.fiscalCode.toLowerCase().indexOf(this.previousFiscalCodeFilter) !== -1);
      const isPartialCreationDateMatch = !this.previousCreationDateFilter || new Date(row.reportDate).toDateString() === this.previousCreationDateFilter.toDateString();
      this.spinnerService.stop();
      return isPartialRequestNumber && isPartialFullName && isPartialEmail && isPartialFiscalCode && isPartialCreationDateMatch;
    });
  }

  columnCreateDateComparator(propA, propB, rowA, rowB) {
    if (rowA.reportDate < rowB.reportDate) { return -1; }
    if (rowA.reportDate > rowB.reportDate) { return 1; }
  }

  columnBirthDateComparator(propA, propB, rowA, rowB) {
    if (new Date(rowA.dateOfBirth) < new Date(rowB.dateOfBirth)) { return -1; }
    if (new Date(rowA.dateOfBirth) > new Date(rowB.dateOfBirth)) { return 1; }
  }

  goToDetail(requestNumber, uuid) {
    localStorage.setItem('candidate_redirect', 'all');
    this.router.navigate([`/report/${requestNumber}/candidate/detail/${uuid}`]);
  }

  exportToExcel(): void {

    this.spinnerService.start();

    this.excelRows = this.exportRows();

    this.commonUtilService.ExportAsExcel('Candidates', this.excelRows, "Tutte le Visure - HRWE.xlsx");

    this.spinnerService.stop();

  }

  exportToPDF(): void {
    this.spinnerService.start();

    this.excelRows = this.exportRows();
    
    this.commonUtilService.ExportAsPDF(true, this.header, this.excelRows, "Tutte le Visure - HRWE.pdf");

  }

  exportRows() {

    this.header = ['Nome Report', 'Data Report', 'Nome e cognome', 'Email', 'Score Degrade', 'Worst 5%', 'Stima Reddito', 'Eventi Negativi'];

    var formatter = new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 3,
    });

    let arr = this.rows.map(rec => {
      return {
        'Nome Report': rec.referencePerson,
        'Data Report': this.datePipe.transform(rec.reportDate, 'dd/MM/yyyy'),
        'Nome e cognome': rec.candidate && rec.candidate.firstName && rec.candidate.lastName ? rec.candidate.firstName + " " + rec.candidate.lastName : ' ',
        'Email': rec.candidate && rec.candidate.email ? rec.candidate.email : ' ',
        'Score Degrade': rec.candidate && rec.candidate.crifResult && rec.candidate.crifResult.degradationScore ?
          this.commonUtilService.getRoundUpScoreVal(rec.candidate.crifResult.degradationScore) : ' ',
        'Worst 5%': rec.candidate && rec.candidate.crifResult && rec.candidate.crifResult.degradationScoreFlag5percentage ?
          this.commonUtilService.getWorstCalResult(rec.candidate.crifResult.degradationScoreFlag5percentage) : ' ',
        'Stima Reddito': rec.candidate && rec.candidate.crifResult && rec.candidate.crifResult.averageIncome ?
          formatter.format(Number(rec.candidate.crifResult.averageIncome)) : ' ',
        'Eventi Negativi': rec.candidate && rec.candidate.cribisResult && rec.candidate.cribisResult.relevanceNegativity ? rec.candidate.cribisResult.relevanceNegativity : ' '
      }
    });

    return arr;
  }

}
